import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './Home';
import Resume from './Resume';
import ResumeFrontend from './ResumeFrontend';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' Component={Home} />
        <Route path='/resume' Component={Resume} />
        <Route path='/resume/frontend' Component={ResumeFrontend} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
